module.exports = __webpack_public_path__ + "static/media/Team 29 - NUCATE.ff9e925d.png";